export default __webpack_public_path__ + "static/media/9f2273bdc842e5e46273998a89df34931581424996077.a0b306fe.webp";